import PropTypes from "prop-types";
import { useEffect, useContext, useState } from "react";
import { useSnackbar } from "notistack";

// @mui
import { LoadingButton } from "@mui/lab";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  Alert,
  alpha,
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  FormControlLabel,
  Tooltip,
  Radio,
  Divider,
  Fade,
  FormControl,
  FormLabel,
  Grid,
  Paper,
  RadioGroup,
  FormGroup,
  Checkbox,
  Stack,
  Typography,
} from "@mui/material";

import SyncIcon from "@mui/icons-material/Sync";
import fbLogo from "../assets/fb.png";
import TabsInteraktCloud from "./TabsRegisternumber";
import FacebookIcon from "@mui/icons-material/Facebook";
import RocketIcon from "@mui/icons-material/Rocket";
import {
  Phone as PhoneIcon,
  Business as BusinessIcon,
} from "@mui/icons-material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { WhatsAppSettingsContext } from "../context/OnboardContex";
import getRedirectUrls from "../services/getRedirectUrls";
import getRedirectMMliteURL from "../services/getRedirectMMliteURL";
import syncProfileDetails from "../services/syncProfileDetails";
import PhoneVerificationDialog from "./PhoneVerificationDialog";
import InstructionSteps from "./InstructionSteps";
import TabsmigrateProvider from "./TabsmigrateProvider";

const migrationSteps = [
  "Go to Facebook Business Settings & click 'WhatsApp accounts' & choose the WhatsApp Business API",
  "Go to Settings & click WhatsApp Manager",
  "Click the link under the Phone number",
  "Verify your Profile",
  "Turn off the Two-step verification",
  "Click the link received in your Business Mail",
  "Click disable 2FA",
];

InteraktCloudSettingsForm.propTypes = {
  isEdit: PropTypes.bool,
  currentSettings: PropTypes.object,
  type: PropTypes.string,
  broadcastLimit: PropTypes.number,
  onboardUrl: PropTypes.string,
  wb_account_name: PropTypes.string,
  emovurCloudSetupWay: PropTypes.string,
  setEmovurCloudSetupWay: PropTypes.func,
};

export default function InteraktCloudSettingsForm() {
  const {
    initialize,
    isMigrating,
    phoneDetails,
    details,
    mmLiteStatus,
    canAddPhone,
    type,
    getCurrentHeaders,
    profiledataname,
  } = useContext(WhatsAppSettingsContext);

  const { enqueueSnackbar } = useSnackbar();

  const [isGettingUrl, setIsGettingUrl] = useState(false);
  const [emovurCloudSetupWay, setEmovurCloudSetupWay] = useState("signup");
  const [isSyncing, setIsSyncing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [confirmDisable2fa, setConfirmDisable2fa] = useState(false);

  // Get headers directly
  const headers = getCurrentHeaders();

  const handleEmovurCloudSetupWay = (e) => {
    setEmovurCloudSetupWay(e.target.value);
  };

  // Get current values directly from context
  const phonenumber = phoneDetails?.senderNumber || "";
  const phonenumberid = phoneDetails?.senderId || "";
  const wabaid = details?.wabaId || "";

  const formatPhoneNumber = (number) => {
    if (!number) return "";
    return `${number.slice(0, 3)} ${number.slice(3, 5)} ${number.slice(
      5,
      7
    )} ${number.slice(7, 13)}`;
  };

  // Set data loaded when we have the necessary data
  useEffect(() => {
    if (details?.wabaId && phoneDetails?.senderNumber) {
      setIsDataLoaded(true);
    }
  }, [details?.wabaId, phoneDetails?.senderNumber]);

  console.log(profiledataname);

  const redirectToLinkWithHeaders = async () => {
    try {
      setIsGettingUrl(true);
      const res = await getRedirectUrls(headers);
      window.open(res?.onboardingUrl, "_Self");
      setIsGettingUrl(false);
    } catch (error) {
      console.log(error);
      setIsGettingUrl(false);
    }
  };

  const mmLiteApi = async () => {
    try {
      setIsGettingUrl(true);
      const res = await getRedirectMMliteURL(headers);
      window.open(res?.onboardUrl, "_Self");
      setIsGettingUrl(false);
    } catch (error) {
      console.log(error);
      setIsGettingUrl(false);
    }
  };

  const handleSync = async () => {
    try {
      setIsSyncing(true);
      await syncProfileDetails(headers);
      enqueueSnackbar("Synced Successfully", {
        variant: "success",
        autoHideDuration: 3000,
      });
      initialize();
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    } finally {
      setIsSyncing(false);
    }
  };

  // Show loading state while data is being loaded

  return (
    <Box sx={type !== "interakt_cloud" && isMigrating !== "1" && { p: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        alignItems="start"
        justifyContent="center"
        sx={{ width: "100%" }}
      >
        <Box
          sx={{
            width: details ? "100%" : { xs: "100%", sm: "50%" },
            mb: 2,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {type === "interakt_cloud" ? (
            <Fade in timeout={800}>
              <Card
                sx={{
                  pb: "10px",
                  width: {
                    xs: "100%",
                    sm: "90%",
                    md: "80%",
                    lg: "60%",
                  },
                  borderRadius: 3,
                  background: "#ffffff",
                  border: "none",
                  position: "relative",
                  overflow: "visible",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                  "&:hover": {
                    boxShadow: "0 15px 40px rgba(0, 0, 0, 0.1)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-end"
                  sx={{ p: "10px 10px 0 10px" }}
                >
                  <Chip
                    icon={
                      <Box
                        sx={{
                          width: "10px",
                          height: "10px",
                          backgroundColor: "#08BA29",
                          borderRadius: "50%",
                          ml: 1,
                        }}
                      />
                    }
                    label="Active"
                    variant="outlined"
                    sx={{
                      borderRadius: "10px",
                      borderColor: alpha("#08BA29", 0.3),
                      color: "#08BA29",
                      fontWeight: 600,
                      px: 2,
                      py: 1.5,
                      fontSize: "0.875rem",
                      "& .MuiChip-icon": {
                        ml: 0.5,
                      },
                    }}
                  />
                </Stack>
                {/* Floating status badge */}
                <Box sx={{ p: 3, pb: 0, pt: 0 }}>
                  {/* Profile Header */}
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={3}
                    sx={{ mb: 4 }}
                  >
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      alignItems="center"
                      spacing={3}
                    >
                      <Box sx={{ position: "relative" }}>
                        <Avatar
                          sx={{
                            width: 100,
                            height: 100,
                            border: "4px solid white",
                            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                          }}
                          alt="profile"
                          src={
                            profiledataname?.numberProfile
                              ?.whatsapp_business_profile?.profile_picture_url
                          }
                        />
                      </Box>

                      <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 700,
                            color: "#2d3748",
                            mb: 0.5,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {profiledataname?.numberProfile?.verified_name}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 500,
                            color: "#718096",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: {
                              xs: "center",
                              sm: "flex-start",
                            },
                            gap: 1,
                          }}
                        >
                          <PhoneIcon
                            fontSize="small"
                            sx={{ color: "#0c9ffa" }}
                          />
                          {formatPhoneNumber(phonenumber)}
                        </Typography>
                      </Box>
                    </Stack>

                    <Button
                      onClick={handleSync}
                      disabled={isSyncing}
                      startIcon={
                        <SyncIcon
                          sx={{
                            animation: isSyncing
                              ? "spin 1.5s linear infinite"
                              : "none",
                            "@keyframes spin": {
                              "0%": { transform: "rotate(0deg)" },
                              "100%": { transform: "rotate(360deg)" },
                            },
                          }}
                        />
                      }
                      variant="soft"
                      sx={{
                        borderRadius: 50,
                        px: 2,
                        py: 1,
                        fontWeight: 600,
                        textTransform: "none",
                        fontSize: 16,
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 8px 20px rgba(12, 159, 250, 0.1)",
                        },
                        "&:active": {
                          transform: "translateY(0)",
                        },
                        transition: "all 0.3s ease",
                        minWidth: 200,
                      }}
                    >
                      {isSyncing ? "Syncing Data..." : "Sync Data"}
                    </Button>
                  </Stack>

                  {/* Info Cards */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "1fr 1fr",
                        lg:
                          mmLiteStatus === "ONBOARDED"
                            ? "1fr 1fr"
                            : "1fr 1fr 1fr",
                      },
                      gap: 2,
                      mb: 3,
                    }}
                  >
                    {/* Business ID Card */}
                    <Paper
                      elevation={0}
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        backgroundColor: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Box
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            backgroundColor: "rgba(139, 92, 246, 0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <BusinessIcon
                            sx={{ color: "#8b5cf6", fontSize: 20 }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600, color: "#2d3748" }}
                          >
                            Business ID
                          </Typography>
                          <Typography variant="body2" sx={{ color: "#4a5568" }}>
                            {wabaid || "Not available"}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>

                    {/* Phone ID Card */}
                    {canAddPhone !== 1 && (
                      <Paper
                        elevation={0}
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              borderRadius: "50%",
                              backgroundColor: "rgba(16, 185, 129, 0.1)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <PhoneIphoneIcon
                              sx={{ color: "#10b981", fontSize: 20 }}
                            />
                          </Box>
                          <Box>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 600,
                                color: "#2d3748",
                                fontSize: 14,
                              }}
                            >
                              Phone Number ID
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#4a5568" }}
                            >
                              {phonenumberid || "Not available"}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    )}

                    {mmLiteStatus === "ONBOARDED" && (
                      <Paper
                        elevation={0}
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              borderRadius: "50%",
                              backgroundColor: "rgba(239, 68, 68, 0.1)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <RocketIcon
                              sx={{ color: "#ef4444", fontSize: 20 }}
                            />
                          </Box>
                          <Box>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 600,
                                color: "#2d3748",
                                fontSize: 14,
                              }}
                            >
                              Fast Marketing Messages
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    )}
                  </Box>

                  {canAddPhone === 1 && (
                    <Button
                      size="small"
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => setOpenDialog(true)}
                    >
                      Add New Number
                    </Button>
                  )}
                </Box>

                <Divider />

                {/* Sync Button */}
                {mmLiteStatus && mmLiteStatus === "ELIGIBLE" && (
                  <>
                    <Divider />
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      sx={{ p: 2, pb: 1 }}
                    >
                      <Button
                        onClick={mmLiteApi}
                        startIcon={<ExitToAppIcon />}
                        variant="soft"
                        sx={{
                          borderRadius: 50,
                          px: 2,
                          py: 1,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: 14,
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 8px 20px rgba(12, 159, 250, 0.1)",
                          },
                          "&:active": {
                            transform: "translateY(0)",
                          },
                          transition: "all 0.3s ease",
                          minWidth: 200,
                        }}
                      >
                        Signup for Fast Marketing Messages
                      </Button>
                      <Alert
                        size="small"
                        severity="warning"
                        sx={{ bgcolor: "warning", p: "0px 16px" }}
                      >
                        (An active ad account in meta is required)
                      </Alert>
                    </Stack>
                  </>
                )}
              </Card>
            </Fade>
          ) : (
            <Stack
              direction="column"
              spacing={2}
              alignItems="start"
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: "500px", md: "600px" },
              }}
            >
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Select one to proceed
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={emovurCloudSetupWay}
                  onChange={handleEmovurCloudSetupWay}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: "10px", sm: "20px" },
                    mt: 1,
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    width: "100%",
                  }}
                >
                  <Card
                    sx={{
                      p: 1,
                      borderRadius: "10px",
                      flex: 1,
                      minWidth: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Tooltip
                      title="If you want to register a new number as your WhatsApp Business API Number, click on ' Register New Number.'"
                      placement="top"
                      arrow
                    >
                      <FormControlLabel
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 600,
                            fontSize: {
                              xs: "12px",
                              sm: "12px",
                              md: "13px",
                              lg: "14px",
                            },
                            whiteSpace: "nowrap",
                          },
                        }}
                        value="signup"
                        control={<Radio size="small" />}
                        label="Register New Number"
                      />
                    </Tooltip>
                  </Card>
                  <Card
                    sx={{
                      p: 1,
                      borderRadius: "10px",
                      flex: 1,
                      minWidth: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Tooltip
                      title="If you already have a WhatsApp Business API number currently being managed by different provider, you can migrate that number using ' Migrate From Different Provider '. When you migrate, all the Templates, Green Tick and Profile details will get migrated."
                      placement="top"
                    >
                      <FormControlLabel
                        sx={{
                          color: "#606060",
                          "& .MuiFormControlLabel-label": {
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 600,
                            fontSize: {
                              xs: "12px",
                              sm: "12px",
                              md: "13px",
                              lg: "14px",
                            },
                            whiteSpace: "nowrap",
                          },
                        }}
                        value="migration"
                        control={<Radio size="small" />}
                        label="Migrate From Different Provider"
                      />
                    </Tooltip>
                  </Card>
                </RadioGroup>
              </FormControl>

              {/* Dynamic Content Area - This is what changes */}
              <Box
                sx={{
                  width: "100%",
                  minHeight: { xs: "auto", sm: "140px" },
                  transition: "all 0.3s ease-in-out",
                }}
              >
                {emovurCloudSetupWay === "signup" ? (
                  <Box sx={{ pt: 2 }}>
                    <LoadingButton
                      sx={{
                        borderRadius: "50px",
                        backgroundColor: "#0c9ffa",
                        minWidth: "250px",
                      }}
                      variant="contained"
                      startIcon={<img src={fbLogo} alt="facebook" width={25} />}
                      loading={isGettingUrl}
                      onClick={() => {
                        redirectToLinkWithHeaders();
                      }}
                    >
                      Connect Facebook Account
                    </LoadingButton>
                  </Box>
                ) : (
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ mt: 1 }}>
                      <InstructionSteps
                        data={migrationSteps}
                        heading={
                          "To Migrate you have to disable 2-Factor Authentication of your current WhatsApp API provider"
                        }
                      />
                    </Box>
                    <FormGroup sx={{ mt: 1, paddingLeft: "14px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={confirmDisable2fa}
                            onChange={() => {
                              setConfirmDisable2fa(!confirmDisable2fa);
                            }}
                          />
                        }
                        label="I have disabled 2-Factor Authentication"
                      />
                    </FormGroup>
                    <Box sx={{ mt: 2, mb: 1 }}>
                      <LoadingButton
                        variant="contained"
                        startIcon={<FacebookIcon />}
                        loading={isGettingUrl}
                        disabled={!confirmDisable2fa}
                        sx={{
                          "&.Mui-disabled": {
                            pointerEvents: "unset",
                            cursor: "not-allowed",
                          },
                          minWidth: "250px",
                        }}
                        onClick={() => {
                          redirectToLinkWithHeaders();
                        }}
                      >
                        Connect Facebook Account
                      </LoadingButton>
                    </Box>
                  </Box>
                )}
              </Box>
            </Stack>
          )}
        </Box>

        {emovurCloudSetupWay === "signup" && (
          <Stack
            direction="column"
            spacing={2}
            sx={{
              width: { xs: "100%", sm: "50%" },
              display: { xs: details ? "none" : "flex", sm: "flex" },
            }}
            alignItems="center"
            justifyContent="center"
          >
            <TabsInteraktCloud />
          </Stack>
        )}
        {emovurCloudSetupWay === "migration" && (
          <Stack
            direction="column"
            spacing={2}
            sx={{
              width: { xs: "100%", sm: "50%" },
              display: { xs: details ? "none" : "flex", sm: "flex" },
            }}
            alignItems="center"
            justifyContent="center"
          >
            <TabsmigrateProvider />
          </Stack>
        )}
      </Stack>

      <PhoneVerificationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        handleSync={handleSync}
        headers={headers}
      />
    </Box>
  );
}
